import jrpc20WSClient from "./jrpc20WSClient";

class employee {
    TOKEN_LS_KEY = 'lt_al';
    USER_INFO_LS_KEY = 'al_user_info';

    token = null;
    wsClient = new jrpc20WSClient(process.env.REACT_APP_BACKEND_WS_URL, process.env.REACT_APP_BACKEND_WS_USR, process.env.REACT_APP_BACKEND_WS_PWD)

    constructor() {
        this.token = localStorage.getItem(this.TOKEN_LS_KEY);
    }

    isLogged() {
        return new Promise((resolve, reject) => {
            if (this.token == null) {
                reject();
            } else {
                let post_data = {
                    user_data: { token: this.token },
                    call_data: {}
                };

                this.wsClient.request('post', 'warehouse/foodWarehouse/wsCheckToken', post_data).then((result) => {
                    resolve(result.user_info);
                }).catch((error) => {
                    reject(error);
                });
            }
        });
    }

    authenticate(data) {
        return new Promise((resolve, reject) => {
            let post_data = {
                call_data: data
            };

            this.wsClient.request('post', 'warehouse/foodWarehouse/wsAuthenticate', post_data).then((result) => {
                this.token = result.call_data.employee.token;
                localStorage.setItem(this.TOKEN_LS_KEY, this.token);

                const userInfo = result.call_data.employee;
                localStorage.setItem(this.USER_INFO_LS_KEY, JSON.stringify(userInfo));

                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    getUserInfo() {
        const stored = localStorage.getItem(this.USER_INFO_LS_KEY);
        if (stored) {
            return JSON.parse(stored);
        }
        return null;
    }

    logout() {
        this.token = null;
        localStorage.removeItem(this.TOKEN_LS_KEY);
        localStorage.removeItem(this.USER_INFO_LS_KEY);
    }
}

export default employee;
